import { useProductParams } from '../../../../hooks/useProductParams';
import { useTranslation } from 'react-i18next';

import NaturalSVG from '../../SVGs/NaturalSVG';
import { EProducts } from '../../../../model/enums';
import ExtraAbsorbentSVG from '../../SVGs/ExtraAbsorbentSVG';
import PlasticTryInfoSVG from '../../SVGs/PlasticTryInfoSVG';
import StressFreeMaintenanceSVG from '../../SVGs/StressFreeMaintenanceSVG';
import EuphoricCalmingSVG from '../../SVGs/EuphoricCalmingSVG';

import styles from './styles.module.scss';
import DigestionSVG from '../../SVGs/DigestionSVG';
import StimulationSVG from '../../SVGs/StimulationSVG';
import VetApprovedSVG from '../../SVGs/VetApprovedSVG';

const GuaranteedSection = () => {
  const { t } = useTranslation();
  const { productType } = useProductParams();
  let content = null;

  switch (productType) {
    case EProducts.grs:
      content = (
        <>
          <p>
            {t('tryRiskFree')}
            {t('tailsWaggingGuarantee')}
          </p>
          <div className={styles.guaranteedItem}>
            <NaturalSVG />
            <p>{t('100natural')}</p>
          </div>
          <div className={styles.guaranteedItem}>
            <ExtraAbsorbentSVG />
            <p>{t('extraAbsorbent')}</p>
          </div>
          <div className={styles.guaranteedItem}>
            <StressFreeMaintenanceSVG />
            <p>{t('stressFreeMaintenance')}</p>
          </div>
        </>
      );
      break;
    case EProducts.acs:
      content = (
        <div className={styles.guaranteedItem}>
          <PlasticTryInfoSVG />
          <p>{t('plasicTrayInfo.info')}</p>
        </div>
      );
      break;
    case EProducts.ctn:
      content = (
        <>
          <div className={styles.guaranteedItem}>
            <NaturalSVG />
            <p>{t('100natural')}</p>
          </div>
          <div className={styles.guaranteedItem}>
            <EuphoricCalmingSVG />
            <p>{t('euphoric&Calming')}</p>
          </div>
          <div className={styles.guaranteedItem}>
            <DigestionSVG />
            <p>{t('supportsDigestion')}</p>
          </div>
          <div className={styles.guaranteedItem}>
            <StimulationSVG />
            <p>{t('mental&PhysicalStimulation')}</p>
          </div>
          <div className={styles.guaranteedItem}>
            <VetApprovedSVG />
            <p>{t('vetApprovedFun')}</p>
          </div>
        </>
      );
      break;

    default:
      content = <></>;
      break;
  }

  return <div className={styles.guaranteedSection}>{content}</div>;
};

export default GuaranteedSection;
